export enum FilterDate {
    NONE = '',
    YESTERDAY = 'yesterday',
    LAST_SEVEN_DAYS = 'last_seven_days',
    LAST_MONTH = 'last_month',
    LAST_TWELVE_MONTHS = 'last_twelve_months',
    LAST_YEAR = 'last_year',
    CUSTOM = 'custom'
}
